import { useState, useEffect } from 'react'
import { Formik, FormikHelpers } from 'formik'
import { Button, Modal } from '../../../../../components'
import { RevisedLeavePolicyModalProps } from '../../../../holidays/components/types'
import SelectField from '../../../../../components/Form/Select'
import { editLeavePolicy } from '../../api'
import { getLeavePolicy } from '../../../../../features/userslisting/createuser/api'
import { useAppSelector, useAppDispatch } from '../../../../../redux/hook'
import {
    HIDE_LOADER,
    SHOW_LOADER,
} from '../../../../../redux/slices/LoaderSlice'
import { SHOW_NOTIFICATION } from '../../../../../redux/slices/showNotificationSlice'

interface LocFormValues {
    policy: string
}

const RevisedPolicy = ({
    show,
    onClose,
    setCurrentLeavePolicy,
    currentLeavePolicy,
    userLeavePolicyId,
    otherUserId,
}: RevisedLeavePolicyModalProps) => {
    const dispatch = useAppDispatch()
    const [leavepolicyOptions, setLeavepolicyOptions] = useState<
        { label: string; value: string }[]
    >([])
    const { id } = useAppSelector((state) => state.persistedReducers.user)

    useEffect(() => {
        const fetchData = async () => {
            dispatch(SHOW_LOADER())
            try {
                const leaveOptions = await getLeavePolicy()
                const transformedpolicy = leaveOptions?.data?.data?.map(
                    (location: any) => ({
                        value: location.id,
                        label: location.title,
                    })
                )
                setLeavepolicyOptions(transformedpolicy)

                // Find the matching leave policy and set it as the current leave policy
                const matchingPolicy = transformedpolicy.find(
                    (policy: any) => policy.value === userLeavePolicyId
                )
                if (matchingPolicy) {
                    setCurrentLeavePolicy(matchingPolicy)
                }
            } catch (error) {
                console.error(error)
            } finally {
                dispatch(HIDE_LOADER())
            }
        }
        fetchData()
    }, [dispatch, userLeavePolicyId, setCurrentLeavePolicy])

    return (
        <Modal
            show={show}
            handleClose={() => onClose(false)}
            title="Select Leave Policy"
            body={
                <Formik
                    initialValues={{
                        policy: currentLeavePolicy
                            ? currentLeavePolicy?.value
                            : '',
                    }}
                    onSubmit={async (
                        values: LocFormValues,
                        actions: FormikHelpers<LocFormValues>
                    ) => {
                        actions.setSubmitting(true)
                        dispatch(SHOW_LOADER())
                        try {
                            const response = await editLeavePolicy(
                                otherUserId ? otherUserId : id,
                                values.policy
                            )

                            if (response.status === 200) {
                                const updatedPolicy = leavepolicyOptions.find(
                                    (policy) => policy.value === values.policy
                                )
                                if (updatedPolicy) {
                                    setCurrentLeavePolicy(updatedPolicy)
                                }
                                dispatch(
                                    SHOW_NOTIFICATION({
                                        message:
                                            'Leave Policy updated successfully',
                                        type: 'success',
                                    })
                                )
                            }
                        } catch (error) {
                            console.error(error)
                        } finally {
                            actions.setSubmitting(false)
                            dispatch(HIDE_LOADER())
                            onClose(false)
                        }
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                    }) => (
                        <form onSubmit={handleSubmit}>
                            <div className="bg-green-color">
                                <SelectField
                                    name="policy"
                                    label="Select Leave Policy"
                                    options={leavepolicyOptions}
                                    value={values.policy}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.policy}
                                    touched={touched.policy}
                                    defaultValue="option1"
                                />
                            </div>
                            <div className="footer-block">
                                <Button disabled={isSubmitting} type="submit">
                                    SAVE
                                </Button>
                                <Button
                                    disabled={isSubmitting}
                                    type="button"
                                    variant="outline-success"
                                    onClick={() => onClose(false)}
                                >
                                    CANCEL
                                </Button>
                            </div>
                        </form>
                    )}
                </Formik>
            }
            onSuccess={() => {
                onClose(false)
            }}
        />
    )
}

export default RevisedPolicy
